<template>
	<a-layout class="adminBox">
		<a-layout-header class="head flexBox">
			<router-link to="/">
			    <img src="../../assets/img/lib/logo.png" class="logo">
			</router-link>
			<div class="btnList flexBox">
				<div class="btn desk" @click="clickDesk">控制台</div>
				<email-modal v-model="editEmail" :type="emailModalType" @success="handleEmailSuccess" />
				<div class="btn quit" @click="clickQuit">退出</div>
			</div>
		</a-layout-header>
		<a-layout>
			<a-layout-sider class="siderBox">
				<a-menu mode="inline" class="menuBox" :selectedKeys="elect">
					<a-menu-item :key="idx" v-for="(item,idx) in menuList" @click="clickMenu(item)">
						<i class="icon"></i>
						<span>{{item.name}}</span>
					</a-menu-item>
				</a-menu>
			</a-layout-sider>
			<a-layout-content class="contentBox">
				<router-view></router-view>
			</a-layout-content>
		</a-layout>
		
	</a-layout>
</template>

<script>
	import GlobalInfo from '../../components/GlobalInfo.vue';
	import EmailModal from '../../components/com/EmailModal.vue';
	export default {
		name: 'Admin',
		components: {
			EmailModal
		},
		data() {
			return {
				elect: [],
				menuList: [{
					name: "账户信息",
					url: "/admin"
				}, {
					name: "购买卡券",
					url: "/admin/buy"
				}, {
					name: "购买记录",
					url: "/admin/order"
				}, {
					name: "我的发票",
					url: "/admin/bill",
					sub: ["/admin/billReq", "/admin/billDes"]
				}, {
					name: "我的合同",
					url: "/admin/pact"
				}, {
					name: "邀请记录",
					url: "/admin/inviteRecord"
				}],
				userData: null,
				editEmail: false,
				emailModalType: 'bind', // 'edit' 或 'bind'
			}
		},
		watch: {
			$route() {
				this.updateRoute()
			}
		},
		mounted() {
			this.updateRoute();
			this.getUserInfo();
			
		},
		methods: {
			getUserInfo() {
				this.$tools.getUserInfo(
				(data) => {
					this.userData = data;
					//this.email=this.userData.email;
				});
			},
			updateRoute() {
				this.$nextTick(() => {
					const res = this.$route;
					const navIdx = this.findNavIdx(res.path);
					if (navIdx != null) {
						this.elect = [navIdx];
					}
				})
			},
			findNavIdx(path) {
				for (let i = 0; i < this.menuList.length; i++) {
					const msg = this.menuList[i];
					if (msg.url == path) {
						return i
					};

					if (msg.sub && msg.sub.indexOf(path) != -1) {
						return i
					}
				};


				return 0
			},
			goDashboard() {
				this.$tools.checkLoginAndJump("https://console.cloud-ming.com/console/portal/dashboard");
			},
			clickDesk() {
				//console.log("---this.userData=",this.userData)
				// 是否已绑定邮箱
				if(this.userData.email == "" || this.userData.email == "cloud-service@zminfra.cn"){
					this.emailModalType = 'bind' ;
					this.editEmail = true;
				}else{
					this.goDashboard();
				}
			},
			handleEmailSuccess() {
				// 邮箱操作成功后的回调函数
				// 更新用户信息
				this.getUserInfo();
				this.goDashboard();
			},
			clickQuit() {
				this.$tools.userLogout(
					() => {
						this.$message.success("注销成功!");
						this.reset();
					},
					(msg) => {
						this.$message.error(msg);
					}
				);
			},
			reset() {
				this.userData = null;
				this.$router.push("/");
			},
			clickMenu(res) {
				this.$router.push(res.url);
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/admin/admin.css");
</style>